import { FinishIllutration } from '../Icons/FinishIllutration'

export const ThirdStep = () => {
  return (
    <div className='flex flex-col justify-center items-center'>
      <FinishIllutration />
      <p className='text-center text-base font-semibold leading-6 text-secondary-imed-60 mt-10'>
        Código validado con éxito.
      </p>
      <p className='text-center text-base font-normal leading-6 text-secondary-imed-60 mt-4'>
        Pronto se abrirá una nueva pestaña con tu factura
      </p>
    </div>
  )
}
